/* ==========================================================================
   DAMTIER Theme v3 — JavaScript
   Matches Scuffers interaction patterns.
   ========================================================================== */

(function() {
  'use strict';

  /* ---------- Header: Transparent → Opaque on scroll ---------- */
  const header = document.getElementById('site-header');
  if (header && header.classList.contains('site-control--transparent')) {
    const hero = document.querySelector('.hero-split');
    if (hero) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          header.classList.toggle('site-control--transparent', entry.isIntersecting);
          header.classList.toggle('site-control--opaque', !entry.isIntersecting);
        },
        { threshold: 0.05 }
      );
      observer.observe(hero);
    } else {
      // No hero — make opaque immediately
      header.classList.remove('site-control--transparent');
      header.classList.add('site-control--opaque');
    }
  }

  /* ---------- Navigation Drawer ---------- */
  const navDrawer = document.getElementById('nav-drawer');
  if (navDrawer) {
    document.querySelectorAll('[data-menu-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        navDrawer.classList.add('sc-drawer--open');
        document.body.classList.add('no-scroll');
      });
    });
    document.querySelectorAll('[data-nav-close]').forEach(btn => {
      btn.addEventListener('click', () => {
        navDrawer.classList.remove('sc-drawer--open');
        document.body.classList.remove('no-scroll');
      });
    });
  }

  /* ---------- Search Modal ---------- */
  const searchModal = document.getElementById('search-modal');
  if (searchModal) {
    document.querySelectorAll('[data-search-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        searchModal.classList.toggle('search-modal--open');
        if (searchModal.classList.contains('search-modal--open')) {
          document.body.classList.add('no-scroll');
          const input = searchModal.querySelector('.search-modal__input');
          if (input) setTimeout(() => input.focus(), 100);
        } else {
          document.body.classList.remove('no-scroll');
        }
      });
    });
    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchModal.classList.contains('search-modal--open')) {
        searchModal.classList.remove('search-modal--open');
        document.body.classList.remove('no-scroll');
      }
    });
  }

  /* ---------- Cart Drawer ---------- */
  const cartContainer = document.getElementById('cart-drawer');
  if (cartContainer) {
    function openCart() {
      cartContainer.classList.add('is-open');
      document.body.classList.add('no-scroll');
    }
    function closeCart() {
      cartContainer.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }

    document.querySelectorAll('[data-cart-toggle]').forEach(el => el.addEventListener('click', openCart));
    document.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));

    // Close on overlay click
    const overlay = cartContainer.querySelector('.cart-drawer--overlay');
    if (overlay) overlay.addEventListener('click', closeCart);
  }

  /* ---------- Location Popup ---------- */
  const locationModal = document.getElementById('location-modal');
  if (locationModal) {
    document.querySelectorAll('[data-country-selector]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        locationModal.style.display = 'block';
        document.body.classList.add('no-scroll');
      });
    });
    document.querySelectorAll('[data-location-close]').forEach(btn => {
      btn.addEventListener('click', () => {
        locationModal.style.display = 'none';
        document.body.classList.remove('no-scroll');
      });
    });
  }

  /* ---------- Product Accordion (+/- icon) ---------- */
  document.querySelectorAll('[data-accordion]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', !expanded);
      const content = trigger.nextElementSibling;
      if (content) {
        if (expanded) {
          content.style.height = '0';
          content.classList.remove('product-accordion__content--open');
        } else {
          content.style.height = content.scrollHeight + 'px';
          content.classList.add('product-accordion__content--open');
        }
      }
    });
  });

  /* ---------- Variant selection (color + size combined) ---------- */
  const variantState = {
    color: null,
    size: null
  };

  function moneyFormat(cents) {
    if (cents == null) return '';
    const symbol = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'USD') ? '$' : '€';
    const amount = (cents / 100).toFixed(2);
    return symbol + amount.replace(/\.00$/, '');
  }

  function findCurrentVariant() {
    if (!window.productVariants || !window.productOptions) return null;
    const opts = window.productOptions;
    return window.productVariants.find(v => {
      let ok = true;
      if (opts.color && variantState.color != null) {
        ok = ok && v['option' + opts.color] === variantState.color;
      }
      if (opts.size && variantState.size != null) {
        ok = ok && v['option' + opts.size] === variantState.size;
      }
      return ok;
    });
  }

  function updateUIForVariant(variant) {
    const variantInput = document.getElementById('product-variant-id');
    const stickyInput = document.querySelector('.sticky-variant-id');
    const inlineATC = document.getElementById('product-atc-inline');
    const stickyATC = document.querySelector('[data-sticky-atc]');
    const priceEl = document.querySelector('[data-current-price]');
    const compareEl = document.querySelector('[data-compare-price]');
    const atcPrice = document.querySelector('[data-atc-price]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const atcLabel = document.querySelector('[data-atc-label]');
    const stickyLabel = document.querySelector('[data-sticky-label]');
    const colorLabel = document.querySelector('[data-current-color]');

    if (!variant) {
      // Combination unavailable
      if (atcLabel) atcLabel.textContent = 'Unavailable';
      if (stickyLabel) stickyLabel.textContent = 'Unavailable';
      if (inlineATC) inlineATC.disabled = true;
      if (stickyATC) stickyATC.disabled = true;
      return;
    }

    if (variantInput) variantInput.value = variant.id;
    if (stickyInput) stickyInput.value = variant.id;

    const priceStr = moneyFormat(variant.price);
    if (priceEl) priceEl.textContent = priceStr;
    if (atcPrice) atcPrice.textContent = priceStr;
    if (stickyPrice) stickyPrice.textContent = priceStr;

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = moneyFormat(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (atcLabel) atcLabel.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    if (stickyLabel) stickyLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
    if (inlineATC) inlineATC.disabled = !variant.available;
    if (stickyATC) stickyATC.disabled = !variant.available;

    if (colorLabel && window.productOptions.color) {
      colorLabel.textContent = variant['option' + window.productOptions.color] || '';
    }

    // Swap main image to variant featured image
    if (variant.featured_image && variant.featured_image.id) {
      const productMedia = document.getElementById('product-media');
      if (productMedia) {
        const targetSlide = productMedia.querySelector(`.product-main-image[src*="${variant.featured_image.id}"]`);
        if (targetSlide) targetSlide.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
      }
    }
  }

  function refreshSizeAvailability() {
    if (!window.productVariants || !window.productOptions) return;
    const opts = window.productOptions;
    if (!opts.size) return;

    document.querySelectorAll('.product-size-pill').forEach(pill => {
      const size = pill.dataset.size;
      const matchVariant = window.productVariants.find(v => {
        let ok = v['option' + opts.size] === size;
        if (opts.color && variantState.color != null) {
          ok = ok && v['option' + opts.color] === variantState.color;
        }
        return ok;
      });
      const available = matchVariant && matchVariant.available;
      pill.classList.toggle('product-size-pill--unavailable', !available);
      pill.disabled = !available;
    });
  }

  // Initialize state from currently active pills/thumbs
  const initialColor = document.querySelector('.product-color-thumb--active');
  const initialSize = document.querySelector('.product-size-pill--active');
  if (initialColor) variantState.color = initialColor.dataset.color;
  if (initialSize) variantState.size = initialSize.dataset.size;
  refreshSizeAvailability();

  // Color thumb clicks
  document.querySelectorAll('.product-color-thumb').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.product-color-thumb').forEach(b => b.classList.remove('product-color-thumb--active'));
      btn.classList.add('product-color-thumb--active');
      variantState.color = btn.dataset.color;
      refreshSizeAvailability();
      updateUIForVariant(findCurrentVariant());
    });
  });

  // Size pill clicks
  document.querySelectorAll('.product-size-pill').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.disabled || btn.classList.contains('product-size-pill--unavailable')) return;
      document.querySelectorAll('.product-size-pill').forEach(b => b.classList.remove('product-size-pill--active'));
      btn.classList.add('product-size-pill--active');
      variantState.size = btn.dataset.size;
      updateUIForVariant(findCurrentVariant());
    });
  });

  /* ---------- Product Thumbnails → Main Image ---------- */
  const productMedia = document.getElementById('product-media');
  if (productMedia) {
    document.querySelectorAll('.product-thumbs__item').forEach(thumb => {
      thumb.addEventListener('click', () => {
        // Update active state
        document.querySelectorAll('.product-thumbs__item').forEach(t => t.classList.remove('product-thumbs__item--active'));
        thumb.classList.add('product-thumbs__item--active');

        // Scroll to corresponding image in media carousel
        const index = parseInt(thumb.dataset.thumbIndex);
        const images = productMedia.querySelectorAll('.product-main-image');
        if (images[index]) {
          images[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // Update active thumb AND dot indicators on scroll
    const slides = productMedia.querySelectorAll('.product-media-slide');
    const images = productMedia.querySelectorAll('.product-main-image');
    const dots = document.querySelectorAll('.product-media-dot');

    if (slides.length > 1) {
      const mediaObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target.querySelector('.product-main-image');
            const idx = img ? img.dataset.index : '0';

            // Update thumbs
            document.querySelectorAll('.product-thumbs__item').forEach(t => t.classList.remove('product-thumbs__item--active'));
            const activeThumb = document.querySelector(`.product-thumbs__item[data-thumb-index="${idx}"]`);
            if (activeThumb) activeThumb.classList.add('product-thumbs__item--active');

            // Update dots
            dots.forEach(d => d.classList.remove('product-media-dot--active'));
            const activeDot = document.querySelector(`.product-media-dot[data-dot-index="${idx}"]`);
            if (activeDot) activeDot.classList.add('product-media-dot--active');
          }
        });
      }, { root: productMedia, threshold: 0.5 });

      slides.forEach(slide => mediaObserver.observe(slide));

      // Tap dot to scroll to slide
      dots.forEach(dot => {
        dot.addEventListener('click', () => {
          const idx = parseInt(dot.dataset.dotIndex);
          if (slides[idx]) {
            slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          }
        });
      });
    }
  }

  /* ---------- Size Guide Modal ---------- */
  const sizeGuideModal = document.getElementById('size-guide-modal');
  if (sizeGuideModal) {
    document.querySelectorAll('[data-size-guide-trigger]').forEach(el => {
      el.addEventListener('click', () => {
        sizeGuideModal.classList.add('size-guide-modal--open');
        document.body.classList.add('no-scroll');
      });
    });
    document.querySelectorAll('[data-size-guide-close]').forEach(el => {
      el.addEventListener('click', () => {
        sizeGuideModal.classList.remove('size-guide-modal--open');
        document.body.classList.remove('no-scroll');
      });
    });
  }

  /* ---------- Filter Drawer ---------- */
  const filterDrawer = document.getElementById('filter-drawer');
  if (filterDrawer) {
    document.querySelectorAll('[data-filter-toggle]').forEach(el => {
      el.addEventListener('click', () => {
        filterDrawer.classList.add('filter-drawer--open');
        document.body.classList.add('no-scroll');
      });
    });
    document.querySelectorAll('[data-filter-close]').forEach(el => {
      el.addEventListener('click', () => {
        filterDrawer.classList.remove('filter-drawer--open');
        document.body.classList.remove('no-scroll');
      });
    });
  }

  /* ---------- Sticky Mobile ATC — only shows when inline ATC scrolls out of view ---------- */
  const stickyBar = document.getElementById('product-sticky-bar');
  const inlineATC = document.getElementById('product-atc-inline');
  if (stickyBar && inlineATC) {
    // Only on mobile
    const mq = window.matchMedia('(max-width: 768px)');

    function setupStickyObserver() {
      if (!mq.matches) {
        stickyBar.style.display = 'none';
        return;
      }

      const atcObserver = new IntersectionObserver(
        ([entry]) => {
          stickyBar.style.display = entry.isIntersecting ? 'none' : 'block';
        },
        { threshold: 0 }
      );
      atcObserver.observe(inlineATC);
    }

    setupStickyObserver();
    mq.addEventListener('change', setupStickyObserver);
  }

  /* ---------- AJAX Add to Cart ---------- */
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(form);

      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (!res.ok) throw new Error('Failed');

        // Refresh cart count
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
        });

        // Open cart drawer
        if (cartContainer) {
          // Refresh drawer content
          try {
            const sectionRes = await fetch('/?sections=cart-drawer');
            const sections = await sectionRes.json();
            if (sections['cart-drawer']) {
              const tmp = document.createElement('div');
              tmp.innerHTML = sections['cart-drawer'];
              const newInner = tmp.querySelector('.cart-drawer--wrapper_inner');
              const currentInner = cartContainer.querySelector('.cart-drawer--wrapper_inner');
              if (newInner && currentInner) {
                currentInner.innerHTML = newInner.innerHTML;
              }
            }
          } catch (err) {
            // Fallback: just open drawer with stale content
          }

          cartContainer.classList.add('is-open');
          document.body.classList.add('no-scroll');
        }
      } catch (err) {
        console.error('Add to cart error:', err);
        form.submit(); // Fallback
      }
    });
  });

  /* ---------- Quick Add (+ button on cards) ---------- */
  document.addEventListener('click', async (e) => {
    const quickAdd = e.target.closest('[data-quick-add]');
    if (!quickAdd) return;
    e.preventDefault();
    e.stopPropagation();

    const variantId = quickAdd.dataset.variantId;
    if (!variantId) return;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      });

      // Update count
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
      });

      // Open cart drawer
      if (cartContainer) {
        cartContainer.classList.add('is-open');
        document.body.classList.add('no-scroll');
      }
    } catch (err) {
      console.error('Quick add error:', err);
    }
  });

  /* ---------- Cart Quantity +/- ---------- */
  document.addEventListener('click', async (e) => {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    const remove = e.target.closest('[data-remove-item]');

    if (!minus && !plus && !remove) return;

    const item = (minus || plus || remove).closest('[data-cart-item]');
    if (!item) return;

    const key = item.dataset.key;
    let qty;

    if (remove) {
      qty = 0;
    } else {
      const qtyEl = item.querySelector('[data-qty-value]');
      qty = parseInt(qtyEl.textContent);
      if (minus) qty = Math.max(0, qty - 1);
      if (plus) qty += 1;
    }

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      // Reload page to refresh cart drawer
      location.reload();
    } catch (err) {
      console.error('Cart update error:', err);
    }
  });

  /* ---------- Escape key closes everything ---------- */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;

    // Close cart
    if (cartContainer && cartContainer.classList.contains('is-open')) {
      cartContainer.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      return;
    }

    // Close nav drawer
    if (navDrawer && navDrawer.classList.contains('sc-drawer--open')) {
      navDrawer.classList.remove('sc-drawer--open');
      document.body.classList.remove('no-scroll');
      return;
    }

    // Close filter drawer
    if (filterDrawer && filterDrawer.classList.contains('filter-drawer--open')) {
      filterDrawer.classList.remove('filter-drawer--open');
      document.body.classList.remove('no-scroll');
      return;
    }

    // Close size guide
    if (sizeGuideModal && sizeGuideModal.classList.contains('size-guide-modal--open')) {
      sizeGuideModal.classList.remove('size-guide-modal--open');
      document.body.classList.remove('no-scroll');
      return;
    }

    // Close location modal
    if (locationModal && locationModal.style.display !== 'none') {
      locationModal.style.display = 'none';
      document.body.classList.remove('no-scroll');
    }
  });

  /* ---------- Drag to scroll (recommendation carousels) ---------- */
  document.querySelectorAll('.product-recommendations .product-list').forEach(track => {
    let isDown = false;
    let startX;
    let scrollLeft;

    track.addEventListener('mousedown', (e) => {
      isDown = true;
      track.style.cursor = 'grabbing';
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener('mouseleave', () => { isDown = false; track.style.cursor = 'grab'; });
    track.addEventListener('mouseup', () => { isDown = false; track.style.cursor = 'grab'; });

    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.5;
      track.scrollLeft = scrollLeft - walk;
    });
  });

})();


/* ==========================================================================
   Collection: filter apply + sort menu
   ========================================================================== */
(function() {
  'use strict';

  /* Filter apply — collect checked boxes into Shopify filter params */
  document.querySelectorAll('[data-filter-apply]').forEach(btn => {
    btn.addEventListener('click', () => {
      const params = new URLSearchParams(window.location.search);
      Array.from(params.keys())
        .filter(k => k.indexOf('filter.') === 0)
        .forEach(k => params.delete(k));
      document.querySelectorAll('#filter-drawer input[type="checkbox"]:checked')
        .forEach(cb => params.append(cb.name, cb.value));
      params.delete('page');
      const qs = params.toString();
      window.location.href = window.location.pathname + (qs ? '?' + qs : '');
    });
  });

  /* Sort menu — popover above the Sort button */
  const sortBtn = document.querySelector('[data-sort-toggle]');
  if (sortBtn) {
    const SORTS = [
      ['manual', 'Featured'],
      ['best-selling', 'Best selling'],
      ['created-descending', 'Newest'],
      ['price-ascending', 'Price: Low to High'],
      ['price-descending', 'Price: High to Low']
    ];
    const current = new URLSearchParams(window.location.search).get('sort_by');
    const menu = document.createElement('div');
    menu.className = 'sort-menu';
    SORTS.forEach(([value, label]) => {
      const opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'sort-menu__option' + (value === current ? ' sort-menu__option--active' : '');
      opt.textContent = label;
      opt.addEventListener('click', () => {
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', value);
        params.delete('page');
        window.location.href = window.location.pathname + '?' + params.toString();
      });
      menu.appendChild(opt);
    });
    menu.style.display = 'none';
    document.body.appendChild(menu);

    sortBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (menu.style.display !== 'none') { menu.style.display = 'none'; return; }
      menu.style.visibility = 'hidden';
      menu.style.display = 'flex';
      const r = sortBtn.getBoundingClientRect();
      const mr = menu.getBoundingClientRect();
      menu.style.left = Math.max(8, Math.min(r.left, window.innerWidth - mr.width - 8)) + 'px';
      menu.style.top = Math.max(8, r.top - mr.height - 8) + 'px';
      menu.style.visibility = 'visible';
    });
    document.addEventListener('click', (e) => {
      if (!menu.contains(e.target) && e.target !== sortBtn) menu.style.display = 'none';
    });
  }
})();


/* ==========================================================================
   Header clearance — measure the real header (+ announcement bar) height and
   expose it as --header-clearance. Fixed CSS values can't know the header's
   padding settings, so we measure.
   ========================================================================== */
(function() {
  'use strict';
  function setHeaderClearance() {
    var header = document.getElementById('site-header');
    if (!header) return;
    var bar = document.querySelector('.header-slider');
    var barH = bar ? bar.offsetHeight : 0;
    header.style.top = barH + 'px';
    document.documentElement.style.setProperty('--header-clearance', (barH + header.offsetHeight) + 'px');
  }
  setHeaderClearance();
  window.addEventListener('load', setHeaderClearance);
  window.addEventListener('resize', setHeaderClearance);
})();
